var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.113845 0.735193L0.170067 0.670067C0.376212 0.463923 0.698788 0.445187 0.926099 0.613845L0.991224 0.670067L6 5.67858L11.0088 0.670067C11.2356 0.443314 11.6032 0.443314 11.8299 0.670067C12.0567 0.896821 12.0567 1.26447 11.8299 1.49122L6.82142 6.5L11.8299 11.5088C12.0361 11.7149 12.0548 12.0375 11.8861 12.2648L11.8299 12.3299C11.6238 12.5361 11.3012 12.5548 11.0739 12.3861L11.0088 12.3299L6 7.32142L0.991224 12.3299C0.764471 12.5567 0.396821 12.5567 0.170067 12.3299C-0.0566863 12.1032 -0.0566863 11.7356 0.170067 11.5088L5.17858 6.5L0.170067 1.49122C-0.0360773 1.28508 -0.0548127 0.962504 0.113845 0.735193Z",
    fill: "#878BA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.841c7123f8edab49934bab5aa4d574cf.svg";
export { ForwardRef as ReactComponent };